/**
 * syncAramFowOverlay — SPY-14 / FID-VIS-02
 * Sync clear disks for live ARAM FoW overlay from viewer + allies + wards.
 */
import { listAramFowClearDisks } from '../../domain/vision/aramFowOverlay.js';
import { listAlliedFowDiskViewers } from '../scene/teamVisionViewers.js';
import { syncFowClearDisks } from '../scene/fowOverlaySceneManager.js';

export function syncAramFowOverlay({
  sceneState,
  viewer,
  activeWards = [],
  team = 'blue',
  gameTime = null,
  THREE,
  activeMinions = [],
  alliedChamps = [],
  alliedViewers = null
} = {}) {
  const clearRoot = sceneState?.fowClearRoot;
  if (!clearRoot) return null;
  const extras = alliedViewers || listAlliedFowDiskViewers(viewer, activeMinions, alliedChamps);
  const disks = listAramFowClearDisks(viewer, activeWards, team, gameTime, extras);
  syncFowClearDisks(clearRoot, disks, THREE);
  return disks;
}
